export const CATEGORY_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
};

export const CATEGORY_STATUSES = [
    { id: CATEGORY_STATUS.ACTIVE, label: "active", color: "#33B950" },
    { id: CATEGORY_STATUS.INACTIVE, label: "inactive", color: "#C4C4C4" },
];
